import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class VaultBanks extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "VaultBanks";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      nickname: null,
      owner: null,
      type: null,
      kind: null,
      routing: null,
      account: null,
      currency: "USD",
      country_code: "US",
      save_token: false,
      send_receipt: true,
      payment_type: 'ACH',
      bank: {
        name: null,
        contact: null,
        email: null,
        website: null,
        routing: null,
        street: null,
        city: null,
        state_code: null,
        postal_code: null,
        country_code: "US",
        phone: null,
        phone_extension: null,
      },
      last_4: null,
      is_test: false,
      customer_id: null,
      company_id: null,
      contact_id: null,
      profile_id: null,
      customer: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,

    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    return data;
  }
}
